export default __webpack_public_path__ + "static/media/IMG-20250105-WA0033.26595814.jpg";